import { useEffect, useState } from 'react';
import { getDevToken, isDevAuthEnabled, subscribeDevToken } from './devAuth';

/** The current dev bypass token, re-rendering on change. Always null when the bypass is off. */
export const useDevToken = (): string | null => {
  const [devToken, setDevToken] = useState(getDevToken);

  useEffect(() => {
    if (!isDevAuthEnabled()) return;
    return subscribeDevToken(() => setDevToken(getDevToken()));
  }, []);

  return devToken;
};
